import { useTranslation } from "react-i18next";
import VideocamIcon from "@mui/icons-material/Videocam";
import "./EvalCameraPermissionBanner.css";

export function EvalCameraPermissionBanner({
  visible = false,
  requesting = false,
  onAllow,
  tablePhone = false,
}) {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <div className="lt-camera-perm" role="region" aria-live="polite">
      <div className="lt-camera-perm__copy">
        <VideocamIcon fontSize="small" aria-hidden />
        <p>
          {tablePhone
            ? t(
                "liveTrainingTablePhoneCameraPrompt",
                "Allow the camera once on this table phone (required on iPhone Safari & Chrome), then leave the page open — the coach can start recording from the tables screen."
              )
            : t(
                "liveTrainingEvalCameraEntryPrompt",
                "Allow the camera now, then put the phone down — evaluation clips will record automatically when the coach starts. You will not be asked again mid-rally."
              )}
        </p>
      </div>
      <button
        type="button"
        className="lt-camera-perm__btn"
        onClick={onAllow}
        disabled={requesting}
      >
        {requesting
          ? t("loading", "Loading…")
          : t("liveTrainingEvalCameraAllow", "Allow camera")}
      </button>
    </div>
  );
}

export default EvalCameraPermissionBanner;
